module.exports = __webpack_public_path__ + "img/ep-logomark-grid.e2ff8f7b.svg";